import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { navigationStep } from "../../../../redux/slices/navigation";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { setDownloadQrType } from "../../../../redux/slices/customizeQr";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";
import Arrow from "../../../../components/navigation/progress/svg/Arrow";

export default function ActionButtons() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.showToggle
  );
  const langNavText = useSelector(
    (state) => state.changeLang.language.nav.desktop
  );
  const typeCard = useSelector((state) => state.typeCard.type);
  const downloadQrType = useSelector(
    (state) => state.customizeQr.downloadQrType
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { entryLocation } = useCurrentLocation();

  const goBack = () => {
    if (typeCard) {
      dispatch(navigationStep(2));
      navigate(`/${typeCard}`);
    } else {
      dispatch(navigationStep(1));
      navigate(`/`);
    }
  };

  return (
    <section className="bg-white p-3 p-md-4 mt-3 mt-md-4 d-none d-lg-block rounded-1">
      <Row className="justify-content-between flex-nowrap">
        <Col xs="auto">
          {!entryLocation && (
            <Button
              variant="outline-primary"
              className="text-capitalize text-nowrap py-2 px-5"
              onClick={goBack}
            >
              <Arrow /> {langNavText[0]}
            </Button>
          )}
        </Col>
        <Col xs={8} xl={6}>
          <div className="d-flex justify-contend-end">
            <div
              key="action-inline-radio"
              className="d-flex justify-content-center align-items-center gap-4 me-4"
            >
              <Form.Check
                checked={downloadQrType === "svg"}
                type="radio"
                label="SVG"
                name="group2"
                id="action-inline-radio-svg"
                onChange={() => dispatch(setDownloadQrType("svg"))}
              />
              <Form.Check
                checked={downloadQrType === "png"}
                type="radio"
                label="PNG"
                name="group2"
                id="action-inline-radio-png"
                onChange={() => dispatch(setDownloadQrType("png"))}
              />
            </div>

            <Button
              id="bottomDownloadBtn"
              variant="primary"
              className="text-capitalize text-nowrap py-2 w-100"
              onClick={() => document.querySelector("#downloadQrCode").click()}
            >
              {lang[4]}
            </Button>
          </div>
        </Col>
      </Row>
    </section>
  );
}
